import AttendanceActivityV3 from './attendanceActivityV3';
import AttendanceActivityV4 from './attendanceActivityV4';

const AttendanceActivity = (props) => {
    if (props.version === 'V3') {
        return (
            <AttendanceActivityV3
                {...props}
            />
        )
    } else {
        return (
            <AttendanceActivityV4
                {...props}
            />
        )
    }
};

export default AttendanceActivity;